<template>
  <div class="home">
    <div class="header fn-15">币种</div>
    <div class="Market fn-12">
      <ul>
        <li
          v-for="(item, index) in SyboList"
          :key="index"
          @click="goLink('/Exchange', item.symbol)"
        >
          <div style="margin-top: 12px">
            <span class="fn-13" style="color: #fff"
              >{{ item.symbol.split("/")[0]
              }}<span style="color: #7b7b7b" class="fn-12"
                >/{{ item.symbol.split("/")[1] }}</span
              ></span
            >
          </div>
          <div>
            <p class="fn-13" :class="item.ref > 0 ? 'color-buy' : 'color-sell'">
              {{ Number(item.last).toFixed(3) }}
            </p>
            <p style="margin-top: 3px">
              ≈{{ Number(item.cnyLast).toFixed(2) }} CNY
            </p>
          </div>
          <div :class="item.raf > 0 ? 'greend' : 'red'">
            <span v-if="Number(item.raf) >= 0"
              >+{{ Number(item.raf * 100).toFixed(2) }} %</span
            >
            <span v-else>{{ Number(item.raf * 100).toFixed(2) }} %</span>
          </div>
        </li>
      </ul>
    </div>
    <Tabbar :active="1"></Tabbar>
  </div>
</template>

<script>
import Vue from "vue";
import { NoticeBar } from "vant";
Vue.use(NoticeBar);
import math from "@/assets/js/math";
var wsPath = "wss://tianyis.me/api/websocket/All/";
var Stomp = require("stompjs");
var SockJS = require("sockjs-client");

export default {
  data() {
    return {
      baseApi: "",
      SyboList: [],
      socketLst: "",
      stompClient: null,
    };
  },
  created() {
    this.baseApi = process.env.VUE_APP_IMG;
    if (this.socketLst == "") {
      this.startWebsock();
    }
  },
  beforeDestroy() {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.disconnect();
      this.stompClient = null;
    }
  },
  methods: {
    initWebSocket() {
      if (typeof WebSocket == "undefined") {
        console.log("您的浏览器不支持WebSocket");
      } else {
        console.log("您的浏览器支持WebSocket");
        let id = this.member ? this.member.userId : Date.now();
        var wsPathStr = wsPath + id;
        var socket = new WebSocket(wsPathStr);
        this.socketLst = socket;
        let that = this;
        socket.onopen = function () {
          that.sendPing(socket);
          setInterval(() => {
            that.sendPing(socket);
          }, 50000);
        };
        socket.onclose = function () {
          console.log("Socket已关闭");
        };
        socket.onerror = function () {
          console.log("Socket发生错误");
        };
      }
    },
    sendPing(socket) {
      let id = this.member ? this.member.userId : Date.now();
      let message = JSON.stringify({
        ping: "ping",
        id: id,
        symbol: this.SyboList.symbol,
      });
      socket.send(message);
    },
    startWebsock() {
      var socket = new SockJS("https://tianyis.me/api/market-ws");
      this.stompClient = Stomp.over(socket);
      this.stompClient.debug = false;
      this.stompClient.connect(
        {},
        (frame) => {
          this.onConnected(this.stompClient);
        },
        this.onError
      );
    },
    onConnected(stompClient) {
      let id = this.member ? this.member.userId : Date.now();
      this.initWebSocket();
      stompClient.subscribe("/topic/cheng/pair/tickers/" + id, (msg) => {
        var resp = JSON.parse(msg.body);
        this.SyboList = resp;
      });
    },
    onError(error) {
      console.log("连接失败", error);
      this.reconnect();
    },
    reconnect() {
      setTimeout(() => {
        this.startWebsock();
      }, 2000);
    },
    goLink(path, item) {
      this.$router.push({
        path,
        query: {
          syboml: JSON.stringify(item),
        },
      });
      localStorage.setItem("symbolEchange", item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/base.scss";

.home {
  .header {
    position: fixed;
    z-index: 999999;
    left: 0;
    right: 0;
    top: 0;
    padding: 10px 0;
    text-align: center;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    color: #fefefe;
  }

  .Market {
    margin-top: 70px;
    ul {
      li {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 10px 10px;
        // background-color: rgba(25, 235, 255, 0.1);
        border: 0.5px solid #f89b19;
        border-radius: 4px;
        margin: 20px;
        div {
          &:nth-child(3) {
            margin-top: 3px;
            padding: 10px 10px;
            color: #fff;
            border-radius: 4px;
          }
          width: 33%;
        }
        .greend {
          background: #00aa66;
          text-align: center;
          width: 90px;
        }
        .red {
          text-align: center;
          background: red;
          width: 90px;
        }
      }
    }
  }
}
</style>
